import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { signOutUser } from "../../../firebase";
import { logoutUser } from "../../../auth/authSlice";

interface SidebarLogoutLinkProps {
    symbol: React.ReactNode;
    text: string;
}

export default function SidebarLogoutLink({ symbol, text }: SidebarLogoutLinkProps) {
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleLogout = async (e: React.MouseEvent) => {
        e.preventDefault();
        if (isLoading) return;

        setIsLoading(true);
        try {
            await signOutUser();
            dispatch(logoutUser());
            navigate("/");
        } catch (error) {
            console.error("Logout failed:", error);
            // Even if Firebase logout fails, we should clear local state
            dispatch(logoutUser());
            navigate("/");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <button
            onClick={handleLogout}
            disabled={isLoading}
            className="text-color sidebar-link badge-left w-100 border-0 bg-transparent text-start"
            style={{ cursor: isLoading ? 'not-allowed' : 'pointer' }}
        >
            <div className="d-flex align-items-center pt-4 pb-4 ms-4">
                <div className="me-3">{symbol}</div>
                <div>{text}</div>
                {isLoading && (
                    <div className="ms-2">
                        <div className="spinner-border spinner-border-sm" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                )}
            </div>
        </button>
    )
}